module.exports = __webpack_public_path__ + "img/cliu2.3f33ea5f.png";